import React from "react";

const TruncateString = props => {
    let { name, length } = props;
    if (!name) {
        name = "";
        return <div>-</div>;
    }
    return (
        <div data-tip={name && name.length > length ? name : ""} data-class="tooltipStyleClass">
            {name && name.length > length ? `${name.substr(0, length - 3)}...` : `${name}`}
        </div>
    );
};
export default TruncateString;

TruncateString.defaultProps = {
    name: "",
    length: 25
};
